import * as React from 'react'
import styled from 'styled-components'
import {theme, getBackgroundColor, Intent, raise} from '../theme'

export interface IButtonProps {
  className?: string
  onClick?: () => void
  color?: string
  disabled?: boolean
  hidden?: boolean
  intent?: Intent
  bgColor?: string
  type?: 'button' | 'submit' | 'reset'
  height?: string
  fontSize?: string
  children?: React.ReactNode
}

class ButtonClass extends React.PureComponent<IButtonProps> {
  static defaultProps: Pick<IButtonProps, 'disabled'> = {
    disabled: false
  }

  public render() {
    return (
      <button
        className={this.props.className}
        type={this.props.type ? this.props.type : 'button'}
        onClick={() => this.props.onClick && this.props.onClick()}
        disabled={this.props.disabled}
        hidden={this.props.hidden}
      >
        {this.props.children}
      </button>
    )
  }
}

export const Button = styled(ButtonClass)`
  position: relative;
  color: ${props => (props.color && props.color === 'white' ? theme.color.red : '#fff')};
  font-size: ${props => (props.fontSize ? props.fontSize : theme.fontSize.small)};
  font-family: ${theme.font.text};
  font-weight: 600;
  text-transform: uppercase;
  background-color: ${props => (props.disabled ? theme.color.gray : (props.color && theme.color[props.color]) || theme.color.red)};
  cursor: ${props => (props.disabled || props.hidden ? 'default' : 'pointer')};
  text-align: center;
  border-radius: 4px;
  border: ${props => (props.color && props.color === 'white' ? `1px solid ${theme.color.red}` : 'none')};
  outline: none;
  padding: 9px 15px 10px;
  width: auto;
  height: ${props => (props.height ? props.height : 'auto')};
  display: flex;
  align-items: center;
  justify-content: center;
  button:disabled {
    background-color: ${theme.color.darkGray} !important;
  }
  opacity: ${props => (props.hidden ? 0 : 1)};
  pointer-events: ${props => (props.hidden ? 'none' : 'auto')};
  @media screen and (max-width: ${theme.breakPoints.mobileMax}px) {
    padding: 6px 12px 8px;
    font-size: ${props => (props.fontSize ? props.fontSize : '1.4rem')};
  }
`
export const PillButton = styled(ButtonClass)`
  position: relative;
  color: #fff;
  font-family: ${theme.font.text};
  font-weight: 600;
  text-align: center;
  background: ${({intent, bgColor}) => (bgColor ? bgColor : getBackgroundColor(intent!))};
  border-radius: 100vh;
  border: none;
  outline: none;
  box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  &:active {
    background: rgba(255, 255, 255, 0.2);
  }

  padding: 10px 20px;
  width: auto;
  height: auto;

  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  &:before {
    content: ' ';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-size: cover;
    opacity: 1;
    z-index: -1;
  }

  transition: all 0.2s;
  &:hover {
    ${raise(2)};
  }
`
